<ion-item>
  <ion-grid>
    <ion-row (click)="toggleExpand()">
      <ion-col size="6"
               class="ion-text-start"
               [class.bold]="isFilterActive">
        {{ filterNameKey | translate }}
      </ion-col>
      <ion-col size="5"
               class="ion-text-end">
        @if (activeFilters > 0 && !disabled) {
          <span class="font-color-light"
                (click)="clearAll($event)">
            {{ 'reports.clear-n' | translate: {filtersNumber: activeFilters} }}
          </span>
        }
      </ion-col>
      <ion-col size="1"
               class="ion-text-end">
        <ion-icon src="assets/icon/icon-expand-arrow.svg"
                  [class.vertical-flip]="isExpanded" />
      </ion-col>
    </ion-row>
    @if (isExpanded) {
        @for (filterItem of filterItems; track filterItem) {
          <app-filter-checkbox [checked]="selectedFilterItems?.includes(filterItem)"
                              [label]="filterItem"
                              [disabled]="disabled"
                              [translateString]="translateString"
                              (change)="onFilterSelect($event, filterItem)" />
        } @empty {
          <div>
            <span class="no-items">{{ 'hedged-orders.filters.filter-names.no-items' | translate }}</span>
          </div>
        }
    }
  </ion-grid>
</ion-item>